import { useState } from 'react';
import Post from "../../helpers/ajax/post";
import { useAuth } from "../../context/auth";
const BypassModal = ({ title, content, showVerifyCode = false, onVerify = () => { }, actions = [], isOpen = true, onClose = () => { }
}) => {
    const [bypassCode, setBypassCode] = useState("");
    const [Error, setError] = useState(null);
    const [isVerifying, setIsVerifying] = useState(false);
    const { user } = useAuth();
    if (!isOpen)
        return null;
    async function verifyCode() {
        setIsVerifying(true);
        try {
            await Post("/api/user/verifyBypassCode", {
                user_id: user.user_id,
                bypassCode: bypassCode
            });
            onVerify(bypassCode);
            onClose();
        } catch (error) {
            setError(error.error);
        } finally {
            setIsVerifying(false);
        }
    }
    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 z-40 overflow-y-auto h-full w-full flex text-center items-center justify-center">
            <div className="bg-white border-4 border-yellow-500 p-8 max-w-md w-full">
                <h2 className="text-2xl md:text-4xl text-yellow-500 mb-4 uppercase">{title}</h2>
                <div className="text-xl md:text-2xl text-dependable font-semibold mb-6">{content}</div>
                <div className="flex justify-between flex-wrap gap-2">
                    {actions.filter(action => action.show !== false).map((action, index) => (action.href ?
                        (<a key={index} href={action.href} target="_blank" rel="noreferrer noopener" className={action.className}> {action.text}</a>) : (<button key={index} onClick={action.onClick} className={action.className}>{action.text}</button>)
                    ))}
                </div>
                {showVerifyCode &&
                    (<>
                        <br />
                        <p className="text-sm md:text-base text-gray-600 mb-2">{actions.length > 0 ?
                            "Or enter your bypass code" : "If you have a bypass code please enter it here"}</p>
                        <div className="flex justify-center items-center mt-1 space-x-2">
                            <input className="text-xs md:text-sm border border-gray-400 text-gray-700 px-3 py-1 w-1/2" type="text" onChange={(e) => setBypassCode(e.target.value)} placeholder="Enter bypass code" />
                            <button className="text-xs md:text-sm border border-dependable-green px-3 py-1 transition duration-300 inline-block hover:bg-dependable-green/80 hover:text-white" onClick={verifyCode} disabled={isVerifying}>{isVerifying ?
                                'Verifying...' : 'Verify code'}</button>
                        </div>
                    </>
                    )}
                {!!Error && (
                    <p className="text-red-600 mt-4 text-base">{Error}</p>)}
            </div>
        </div>
    );
};
export default BypassModal;
